import React from 'react'
import { Link } from 'react-router-dom'
import { Newspaper, Calendar, ArrowRight } from 'lucide-react'
import { PublicFooter } from '../components/layout/PublicFooter'
import { PublicNavigation } from '../components/layout/PublicNavigation'

export const BlogPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 relative overflow-hidden transition-colors duration-300">
      <PublicNavigation />

      {/* Hero Section */}
      <section className="py-20 lg:py-32 relative z-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#69adba]/10 dark:bg-[#69adba]/20 rounded-full mb-6">
              <Newspaper className="h-8 w-8 text-[#69adba]" />
            </div>
            <h1 className="text-4xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-6xl mb-6">
              Blog & Insights
            </h1>
            <p className="mt-6 text-lg leading-8 text-slate-600 dark:text-slate-400">
              Stay informed with the latest news, tips, and insights about 1031 exchanges.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-20 relative z-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Blog Post 1 */}
            <article className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg border border-slate-200 dark:border-slate-700 overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-gradient-to-br from-[#69adba] to-[#5a9aa6]"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-slate-600 dark:text-slate-400 mb-3">
                  <Calendar className="h-4 w-4 mr-2" />
                  <span>January 15, 2025</span>
                </div>
                <h3 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-2">
                  Understanding the 45-Day Identification Rule
                </h3>
                <p className="text-slate-600 dark:text-slate-400 mb-4">
                  Learn everything you need to know about identifying replacement properties within the 45-day window.
                </p>
                <a href="#" className="text-[#69adba] hover:text-[#5a9aa6] font-medium flex items-center">
                  Read More <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </div>
            </article>

            {/* Blog Post 2 */}
            <article className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg border border-slate-200 dark:border-slate-700 overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-gradient-to-br from-[#69adba] to-[#5a9aa6]"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-slate-600 dark:text-slate-400 mb-3">
                  <Calendar className="h-4 w-4 mr-2" />
                  <span>January 10, 2025</span>
                </div>
                <h3 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-2">
                  Common Mistakes in 1031 Exchanges
                </h3>
                <p className="text-slate-600 dark:text-slate-400 mb-4">
                  Avoid these common pitfalls that can disqualify your exchange or delay the process.
                </p>
                <a href="#" className="text-[#69adba] hover:text-[#5a9aa6] font-medium flex items-center">
                  Read More <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </div>
            </article>

            {/* Blog Post 3 */}
            <article className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg border border-slate-200 dark:border-slate-700 overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-gradient-to-br from-[#69adba] to-[#5a9aa6]"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-slate-600 dark:text-slate-400 mb-3">
                  <Calendar className="h-4 w-4 mr-2" />
                  <span>January 5, 2025</span>
                </div>
                <h3 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-2">
                  Maximizing Tax Benefits with 1031 Exchanges
                </h3>
                <p className="text-slate-600 dark:text-slate-400 mb-4">
                  Strategies for deferring capital gains taxes and building wealth through property exchanges.
                </p>
                <a href="#" className="text-[#69adba] hover:text-[#5a9aa6] font-medium flex items-center">
                  Read More <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-20 bg-[#69adba] dark:bg-[#5a9aa6]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-4">
            Stay Updated
          </h2>
          <p className="mt-4 text-lg text-white/90 mb-8">
            Subscribe to our newsletter for the latest 1031 exchange insights and updates.
          </p>
          <div className="max-w-md mx-auto flex gap-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 rounded-xl border border-white/20 bg-white/10 text-white placeholder:text-white/70 focus:outline-none focus:ring-2 focus:ring-white/50"
            />
            <button className="px-6 py-3 bg-white text-[#69adba] rounded-xl font-medium hover:bg-slate-50 transition-colors">
              Subscribe
            </button>
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  )
}

